<div class="template-form" id="vendor-template-layout-template-form">
  <div id="vendor-template-layout-vendor-info-div">
    <div class="col-md srch-area" id="vendor-template-layout-search-area">
      <search-template [data]="flag" (selectedTemplate)="getSelectedTemplateInfo($event)" id="vendor-template-layout-search-template"></search-template>
      <app-template-viewer [data]="templateData" [update]="update" id="vendor-template-layout-app-template-viewer"></app-template-viewer>
    </div>
  </div>
</div>

